import { RichSelect } from 'common-front/src/designSystem/form/richSelect';
import { useHeavent } from 'common-front/src/hooks/useHeavent';
import * as React from 'react';
import { useWorkflowCampaignsQuery } from '../../../generated/graphqlHooks';
import { WorkflowBox } from '../workflowBox';

export const WorkflowSendCampaignStep = () => {
    const {
        translate,
        params: { eventId }
    } = useHeavent();
    const { data } = useWorkflowCampaignsQuery({ eventId });

    return (
        <WorkflowBox
            category={translate('liste_des_campa_60034')}
            icon="paper-plane"
            title={translate('la_campagne_sui_83193')}
        >
            <RichSelect
                isSearchVisible={true}
                name="workflow.data.campaignId"
                placeholder={translate('choisir_une_cam_60181')}
            >
                {(data.event?.campaigns.nodes ?? []).map((campaign) => (
                    <option key={campaign.id} value={campaign.id}>
                        {campaign.name}
                    </option>
                ))}
            </RichSelect>
        </WorkflowBox>
    );
};
